import { render, staticRenderFns } from "./ReceptionContactDetailView.vue?vue&type=template&id=1d5a77b2&"
import script from "./ReceptionContactDetailView.vue?vue&type=script&lang=ts&"
export * from "./ReceptionContactDetailView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports